import { AccountInformationType } from '@va/types/account';
import { WebsiteResponse } from '@va/types/website';
import { getFullName, isWixMiniApp } from '@va/util/helpers';

/**
 * For AAAS, the email can be a GUID. This is why we check for "@"
 */
function getEmail(accountInformation: AccountInformationType, websiteInfo: WebsiteResponse) {
  return accountInformation?.email && accountInformation?.email.includes('@')
    ? accountInformation.email
    : websiteInfo.email;
}

function getName(accountInformation: AccountInformationType, websiteInfo: WebsiteResponse) {
  return accountInformation?.firstName || accountInformation?.lastName
    ? getFullName(accountInformation)
    : getFullName(websiteInfo as WebsiteResponse);
}

/**
 * Wix Mini is treated as AAAS on the BE, but we label it as wix-mini here for the support team
 */
function getPlatform(websiteInfo: WebsiteResponse) {
  return isWixMiniApp() ? 'wix-mini' : websiteInfo?.platform;
}

export const ChatwootHelpers = {
  getEmail,
  getName,
  getPlatform,
};
